import React from "react";
import { TorahAnytimeWizardLayoutTemplate } from "themes/application/torah-anytime/components";

function TorahAnytimeWizardLayout(props) {
    return <TorahAnytimeWizardLayoutTemplate {...props} />;
}

export default TorahAnytimeWizardLayout;
